require('./aggregatorAddEntityView.scss');

// @vendors
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// @components
import { AggregatorAddEntity } from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntity';
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
import { AddBankView } from '../../aggregatorTink/addBankView/addBankView';

import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

class AggregatorAddEntityViewClass extends React.PureComponent {
  handleOnConfirmLeave() {
    this.props.history.push(`/myprofile/global`);
  }

  render() {
    const isTinkAggregator = this.props.immFlagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    return isTinkAggregator ? (
      <AddBankView />
    ) : (
      <AggregatorAddEntityLayout>
        <AggregatorAddEntity
          setWillCancel={() => null}
          onConfirmLeave={() => this.handleOnConfirmLeave()}
        />
      </AggregatorAddEntityLayout>
    );
  }
}

// module.exports.constructor = AggregatorAddEntityView;
// module.exports.AggregatorAddEntityView = AggregatorAddEntityView

const AggregatorAddEntityView = connect(
  state => ({
    immFlagBasedFeatures: state.flagBasedFeatures,
  }),
  {}
)(withRouter(AggregatorAddEntityViewClass));

AggregatorAddEntityViewClass.propTypes = {
  history: PropTypes.object.isRequired,
  immFlagBasedFeatures: PropTypes.object,
};

export { AggregatorAddEntityView };
